module.exports = __webpack_public_path__ + "img/8.7.Chla.e5f2c5fc.png";